// Opts a single computation out of React Compiler memoization. Needed for values
// from libraries the compiler can't safely memoize (e.g. TanStack Virtual's
// `getVirtualItems()`), without de-opting the whole surrounding component.
// See https://github.com/TanStack/virtual/issues/743
export function useNoMemo(factory) {
  'use no memo';
  return factory();
}
